module.exports = __webpack_public_path__ + "img/download.95f09bcb.png";